import { Direction } from '@angular/cdk/bidi';
import { Component, Input, OnInit } from '@angular/core';
import { LanguageService } from 'src/app/@shared/services/language/language.service';

@Component({
    selector: 'app-stop-indicator',
    templateUrl: './stop-indicator.component.html',
    styleUrls: ['./stop-indicator.component.scss'],
    standalone: false
})
export class StopIndicatorComponent implements OnInit {
  @Input() defaultClass: string;
  @Input() topLineClass: string;
  @Input() bottomLineClass: string;
  @Input() isFirstStop: boolean;
  @Input() isLastStop: boolean;
  @Input() isPedestrian: boolean = false;

  direction: Direction

  constructor(private readonly languageService: LanguageService) { }

  ngOnInit(): void {
    this.languageService.selectedLanguage$.subscribe(language => {
      this.direction = language.direction
    })
  }
}
